import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import BasicAddressData from "../BasicAddressData/BasicAddressData";
import InputComponent from "../../UI/InputComponent/InputComponent";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import "./NameAndAddressData.css";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";

const NameAndAddressData = (props) => {
  const competentBodyData = props.parentState.newFormData[props.group].find(
    (element) => element.id === props.id
  );

  const arrayLength = props.parentState.newFormData[props.group].length > 1;

  return (
    <>
      <Row>
        <ColDynamic className="col-lg-8 naz-nad-tj-style">
          <InputComponent
            value={competentBodyData.nazTijela}
            id={`comp-body-data-naziv-tijela${props.id}`}
            name="nazTijela"
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: props.group }}
            controlLabel={"Naziv nadležnog tijela"}
          />
        </ColDynamic>
      </Row>
      <BasicAddressData
        required={props.required}
        requiredKbr={props.requiredKbr}
        id={props.id}
        hackId="comp-body-data"
        onChange={props.mappedUserInputHandler}
        objData={{ id: props.id, group: props.group }}
        address={competentBodyData}
        {...props}
      />

      <Row>
        <ColDynamic className="col-lg-4">
          {props.parentState.newFormData[props.group].length - 1 === props.idZaBtn ? 
          <ButtonComponent
            id={`comp-body-data-multiply${props.id}`}
            onClick={(e) =>
              props.multiplyComponent(e, { formGroup: props.group })
            }
          >
            Dodaj novi
          </ButtonComponent>
          :null
        }
          
        </ColDynamic>
        <ColDynamic className="col-lg-4">
          {arrayLength && (
            <ButtonComponent
              variant="danger"
              id={`comp-body-data-remove${props.id}`}
              onClick={(e) =>
                props.removeComponentHandler(e, { formGroup: props.group })
              }
            >
              Ukloni
            </ButtonComponent>
          )}
        </ColDynamic>
      </Row>
    </>
  );
};

export default NameAndAddressData;
